// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root___NvX6","buttons":"styles_buttons__1Y8Yt"};